import React, { useEffect, useMemo, useState } from "react";
import { Pressable, ScrollView, View, useWindowDimensions, Image } from "react-native";
import { appColors, appFonts, fontSize } from "../../themes/appTheme";
// import { appColors, appFonts, fontSize } from 'zen-core-elements/src/shared/constants'
import CommonHeader from "../../shared/commonComponents/commonHeader";
import { Divider, Icon } from "@rneui/base";
import { NavigationProp, useNavigation } from "@react-navigation/native";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import Popover from "react-native-popover-view/dist/Popover";
import CommonDialogBox from "../../shared/commonComponents/commonDialogBox";
import { DialogBoxType } from '../giftCard/giftCardModule'
import { getUserActivities, logOutCurrentUser, setClockOutDevice } from "../../redux/slices/commonSlice";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { currencyStandard, ZenButton, ZenIcon, ZenLoader, ZenText } from "zen-core-elements";
import { CustomModal } from "../../shared/commonComponents/customModal";
import { config } from "../../shared/environment";
import moment from "moment";

export type NavigationType = {
    'MyAccount': {};
    'ActivityLogs': {};
    'BillingPlans': {};
    'HelpCenter': {}
}

const AccountSettings = () => {

    const { value: currentUser } = useAppSelector((state) => state?.common?.currentUser)
    const dispatch = useAppDispatch()


    const [logOutPopOver, setLogOutPopOver] = useState(false)
    const [confiramtionData, setConfiramtionData] = useState<DialogBoxType | null>()
    const [transparentLoad, setIsTransParentload] = useState(false)
    const userActivities = useAppSelector((state) => state?.common?.userActivities)
    const dummyData = {
        todaySale: "0",
        weeklySale: "307775.00",
        monthlySale: "307775.00",
        lastClockIn: "2026-01-28T08:58:25.000Z"
    }

    const profileList = [
        { id: "1", name: 'my account', navigation: 'MyAccount', iconName: 'person-outline', type: 'ionicon' },
        { id: "2", name: 'activity logs ', navigation: 'ActivityLogs', iconName: 'history', type: 'material-community' },
        { id: "3", name: 'logout', navigation: 'ClockInOutScreen', iconName: 'logout', type: 'material' }
    ]

    const salelist = useMemo(() => [
        { id: "1", name: 'today sale', amount: userActivities?.value?.todaySale || 0 },
        { id: "2", name: 'weekly sale', amount: userActivities?.value?.weeklySale || 0 },
        { id: "3", name: 'monthly sale', amount: userActivities?.value?.monthlySale || 0 }
    ], [userActivities])

    const color = (res: string) => {
        let colorCode = ''
        if (res == '1') {
            colorCode = '#DBF3FA'
        }
        else if (res == '2') {
            colorCode = '#F4FDE4'
        }
        else if (res == '3') {
            colorCode = '#DBFAE0'
        }
        else if (res == '4') {
            colorCode = '#D7DAF2'
        }
        else if (res == '5') {
            colorCode = '#FFFAF0'
        }
        else if (res == '6') {
            colorCode = '#FFFAF0'
        }
        return colorCode
    }

    useEffect(() => {
        getUserActivitiesApi()
    }, [])

    const getUserActivitiesApi = () => {
        dispatch(getUserActivities({ userId: currentUser?.userId!, storeId: config.storeId }))
    }

    useEffect(() => {
        if (logOutPopOver) {
            if (confiramtionData?.id == 2) {
                setLogOutPopOver(false)
                setIsTransParentload(!transparentLoad)
                dispatch(logOutCurrentUser({ data: { infoId: currentUser?.infoId } })).unwrap().then(async (res) => {
                    if (res.success) {
                        await AsyncStorage?.removeItem("Email")
                        setConfiramtionData(null)
                        dispatch(setClockOutDevice(true))
                        setIsTransParentload(false)
                        dispatch({ type: 'RESET_STORE' })
                    }
                }).catch((err) => {
                    console.log("error in the logOutCurrentUser", err);
                    setIsTransParentload(false)
                })
            }
            else {
                setLogOutPopOver(false)
                setConfiramtionData(null)
            }
        }
    }, [confiramtionData])


    const width: any = useWindowDimensions().width
    const naviagtion: NavigationProp<NavigationType> = useNavigation()

    const navigateToScreen = (screenName: string) => {
        switch (screenName) {
            case 'MyAccount':
                naviagtion.navigate(screenName, {});
                break;
            case 'ActivityLogs':
                naviagtion.navigate(screenName, {});
                break;
            default:
                console.warn(`Unknown screen: ${screenName}`);
        }
    };

    return (
        <View style={{ flex: 1, backgroundColor: appColors.lightBackgroundColor }}>
            <CommonHeader headerName="Account" />
            <ScrollView showsVerticalScrollIndicator={false}>
                <View style={{ marginVertical: 15, marginHorizontal: 15, paddingHorizontal: 15, paddingVertical: 10, backgroundColor: appColors.light, borderRadius: 10 }}>
                    <View style={{ flexDirection: width > 450 ? 'row' : 'column', justifyContent: 'space-between', alignItems: width > 500 ? 'center' : undefined }}>
                        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                            <Image source={{ uri: currentUser?.profileImage ? config.AWSImageUrl + currentUser.profileImage : "https://as2.ftcdn.net/v2/jpg/03/64/21/11/1000_F_364211147_1qgLVxv1Tcq0Ohz3FawUfrtONzz8nq3e.jpg" }} style={{ width: width > 600 ? 50 : 60, height: width > 600 ? 50 : 60, borderRadius: 40, marginRight: 10 }} />
                            <View style={{ paddingHorizontal: 10 }}>
                                <ZenText content={currentUser?.name} color={appColors.primary} bold size={'medium'} style={{ textTransform: 'capitalize' }} />
                                <ZenText content={currentUser?.email} color={appColors.grey} size={'medium'} />
                            </View>
                        </View>

                    </View>

                </View>

                <View style={{ marginHorizontal: 15, backgroundColor: appColors.light, borderRadius: 10, flexDirection: 'row', justifyContent: 'space-evenly', paddingVertical: 10 }}>
                    {
                        salelist?.map((list: any, index: number) => (
                            <View key={index} style={{ alignItems: 'center', flexDirection: 'row', paddingHorizontal: width > 600 ? 90 : 10, borderRightWidth: list.id == 2 ? 1 : 0, borderRightColor: list.id == 2 ? appColors.lightGrey : appColors.light, borderLeftWidth: list.id == 2 ? 1 : 0, borderLeftColor: list.id == 2 ? appColors.lightGrey : appColors.light }}>
                                <View style={{ justifyContent: 'space-between', marginTop: 10, alignItems: 'center' }}>
                                    <ZenText content={list?.name} bold style={{ textTransform: 'capitalize' }} size={'medium'} color={appColors.dark} />
                                    <ZenText content={currentUser?.purchasedCurrency?.currencySymbol! + list?.amount} bold style={{ textTransform: 'capitalize', paddingVertical: 10 }} size={'medium'} color={appColors.green} />
                                </View>
                            </View>
                        ))
                    }
                </View>

                <View style={{ flexDirection: 'column', marginHorizontal: 15, backgroundColor: appColors.light, borderRadius: 10, marginVertical: 15 }}>
                    {
                        profileList.map((i, index: number) => (
                            <View key={index}>
                                <Pressable style={{ paddingHorizontal: 15, paddingVertical: 20, flexDirection: 'row', justifyContent: 'space-between', marginVertical: 10, alignItems: 'center', }}
                                    onPress={() => {
                                        if (index == profileList.length - 1) {
                                            setLogOutPopOver(!logOutPopOver)
                                        }
                                        else {
                                            navigateToScreen(i.navigation)
                                        }
                                    }}>
                                    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                        <Icon name={i.iconName} type={i.type} size={30} color={appColors.grey} style={{ backgroundColor: color(String(index + 1)), padding: 5, marginHorizontal: 4, borderRadius: 10 }} />
                                        <ZenText content={i.name} size={'medium'} bold style={{ textTransform: 'capitalize', paddingHorizontal: 10 }} color={appColors.lightDark} />
                                    </View>
                                    <Icon name={"chevron-right"} type={"material-community"} size={25} color={appColors.dark} style={{ backgroundColor: appColors.lightBackgroundColor, padding: 5, marginHorizontal: 4, borderRadius: 5 }} />
                                </Pressable>
                                {profileList.length - 1 != index && <Divider color={appColors.lightGrey} />}
                            </View>
                        ))
                    }

                </View>
            </ScrollView >

            <CustomModal visible={transparentLoad} transparent={true}>
                <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', backgroundColor: appColors.transparent }}>
                    <ZenLoader lottieType="Local" lottie={require("../../assets/infinityLoader.json")} />
                </View>
            </CustomModal>

            <Popover isVisible={logOutPopOver} >
                <CommonDialogBox type="LOGOUT" confirmation={setConfiramtionData} replaceValue={""} />
            </Popover>


        </View >
    )
}
export default AccountSettings